import { IBrick } from "../types/block";

export const BLOCK_MATRIX: number[][][][] = [
  [
    [
      [0, 0, 0, 0],
      [0, 3, 6, 0],
      [0, 9, 12, 0],
      [0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0],
      [0, 3, 6, 0],
      [0, 9, 12, 0],
      [0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0],
      [0, 3, 6, 0],
      [0, 9, 12, 0],
      [0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0],
      [0, 3, 6, 0],
      [0, 9, 12, 0],
      [0, 0, 0, 0],
    ],
  ],
  [
    [
      [0, 0, 0, 0],
      [0, 3, 14, 0],
      [11, 12, 0, 0],
      [0, 0, 0, 0],
    ],
    [
      [7, 0, 0, 0],
      [9, 6, 0, 0],
      [0, 13, 0, 0],
      [0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0],
      [0, 3, 14, 0],
      [11, 12, 0, 0],
      [0, 0, 0, 0],
    ],
    [
      [7, 0, 0, 0],
      [9, 6, 0, 0],
      [0, 13, 0, 0],
      [0, 0, 0, 0],
    ],
  ],
  [
    [
      [0, 0, 0, 0],
      [11, 6, 0, 0],
      [0, 9, 14, 0],
      [0, 0, 0, 0],
    ],
    [
      [0, 7, 0, 0],
      [3, 12, 0, 0],
      [13, 0, 0, 0],
      [0, 0, 0, 0],
    ],
    [
      [0, 0, 0, 0],
      [11, 6, 0, 0],
      [0, 9, 14, 0],
      [0, 0, 0, 0],
    ],
    [
      [0, 7, 0, 0],
      [3, 12, 0, 0],
      [13, 0, 0, 0],
      [0, 0, 0, 0],
    ],
  ],
  [
    [
      [0, 0, 0, 0],
      [3, 10, 14, 0],
      [13, 0, 0, 0],
      [0, 0, 0, 0],
    ],
    [
      [11, 6, 0, 0],
      [0, 5, 0, 0],
      [0, 13, 0, 0],
      [0, 0, 0, 0],
    ],
    [
      [0, 0, 7, 0],
      [11, 10, 12, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
    ],
    [
      [0, 7, 0, 0],
      [0, 5, 0, 0],
      [0, 9, 14, 0],
      [0, 0, 0, 0],
    ],
  ],
  [
    [
      [0, 0, 0, 0],
      [11, 10, 6, 0],
      [0, 0, 13, 0],
      [0, 0, 0, 0],
    ],
    [
      [0, 7, 0, 0],
      [0, 5, 0, 0],
      [11, 12, 0, 0],
      [0, 0, 0, 0],
    ],
    [
      [7, 0, 0, 0],
      [9, 10, 14, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
    ],
    [
      [0, 3, 14, 0],
      [0, 5, 0, 0],
      [0, 13, 0, 0],
      [0, 0, 0, 0],
    ],
  ],
  [
    [
      [0, 0, 0, 0],
      [11, 10, 10, 14],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
    ],
    [
      [0, 7, 0, 0],
      [0, 5, 0, 0],
      [0, 5, 0, 0],
      [0, 13, 0, 0],
    ],
    [
      [0, 0, 0, 0],
      [11, 10, 10, 14],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
    ],
    [
      [0, 7, 0, 0],
      [0, 5, 0, 0],
      [0, 5, 0, 0],
      [0, 13, 0, 0],
    ],
  ],
  [
    [
      [0, 0, 0, 0],
      [11, 2, 14, 0],
      [0, 13, 0, 0],
      [0, 0, 0, 0],
    ],
    [
      [0, 7, 0, 0],
      [11, 4, 0, 0],
      [0, 13, 0, 0],
      [0, 0, 0, 0],
    ],
    [
      [0, 7, 0, 0],
      [11, 8, 14, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
    ],
    [
      [0, 7, 0, 0],
      [0, 1, 14, 0],
      [0, 13, 0, 0],
      [0, 0, 0, 0],
    ],
  ],
];

export class Brick implements IBrick {
  constructor(
    public x: number,
    public y: number,
    public t: number,
    public color: number,
    public to: number[]
  ) {}
}

class Block {
  quel: number;
  rotation: number;
  x: number;
  y: number;
  posX: number;
  posY: number;
  color: number;

  constructor(quel: number, color: number, x: number = 0, y: number = 0) {
    this.quel = quel;
    if (color !== -1) this.color = color;
    else this.color = this.quel;
    this.x = x;
    this.y = y;
    this.calcPosXY();
    this.posY -= 17 << 4;
    this.rotation = 0;
  }

  getBlueprint(): Brick[] {
    let block: Brick[] = [];
    for (let row = 0; row < 4; row++) {
      for (let col = 0; col < 4; col++) {
        let t: number = BLOCK_MATRIX[this.quel][this.rotation][row][col];
        if (t) {
          let to = [
            col > 0 ? BLOCK_MATRIX[this.quel][this.rotation][row][col - 1] : 0,
            row > 0 ? BLOCK_MATRIX[this.quel][this.rotation][row - 1][col] : 0,
            col < 3 ? BLOCK_MATRIX[this.quel][this.rotation][row][col + 1] : 0,
            row < 3 ? BLOCK_MATRIX[this.quel][this.rotation][row + 1][col] : 0,
          ];
          let brick = new Brick(col, row, t & 15, this.color, to);
          block = [...block, brick];
        }
      }
    }
    return block;
  }

  getDimensions(): { width: number; height: number } {
    let rows: number[] = [];
    let cols: number[] = [];
    for (let row = 0; row < 4; row++) {
      for (let col = 0; col < 4; col++) {
        if (BLOCK_MATRIX[this.quel][this.rotation][row][col]) {
          if (!rows.includes(row)) rows = [...rows, row];
          if (!cols.includes(col)) cols = [...cols, col];
        }
      }
    }
    return { width: cols.length, height: rows.length };
  }

  calcPosXY(): void {
    this.posX = ((this.x - 4) * 18) << 4;
    this.posY = ((this.y - 12) * 18) << 4;
  }
}

export default Block;
